import React from "react";

const Blog = () => {
  return <>Blog page</>;
};

export { Blog };
